import './affine-link.js';

export { AffineLink } from './affine-link.js';
